"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DependentFormControlledSelect = void 0;
var core_1 = require("@material-ui/core");
var acid_components_1 = require("@michelin/acid-components");
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
function DependentFormControlledSelect(props) {
    var name = props.name, rules = props.rules, control = props.control, label = props.label, options = props.options, readOnly = props.readOnly, loading = props.loading, error = props.error, helperText = props.helperText, dependencies = props.dependencies, onDependenciesChanged = props.onDependenciesChanged;
    var watchedValue = react_hook_form_1.useWatch({
        name: dependencies,
        control: control,
    });
    react_1.useEffect(function () {
        if (watchedValue) {
            // TODO: this should be typed more strictly
            var values_1 = {};
            var shouldTriggerDependenciesChanged_1 = true;
            dependencies.forEach(function (dep, idx) {
                if (watchedValue[idx] !== undefined) {
                    values_1[dep] = watchedValue[idx];
                }
                else {
                    shouldTriggerDependenciesChanged_1 = false;
                }
            });
            if (shouldTriggerDependenciesChanged_1) {
                onDependenciesChanged(values_1);
            }
        }
    }, [watchedValue]);
    return (react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: name, rules: rules, render: function (_a) {
            var field = _a.field;
            return (react_1.default.createElement(acid_components_1.Select, __assign({ id: name, label: label, options: !options || loading ? [] : options, error: error, helperText: helperText, readOnly: readOnly || loading || !options || options.length === 0, required: !!(rules === null || rules === void 0 ? void 0 : rules.required), fullWidth: true }, field, { startAdornment: loading
                    ? (react_1.default.createElement(core_1.InputAdornment, { position: "start" },
                        react_1.default.createElement(acid_components_1.LoadingBounce, { size: "8px" }))) : undefined })));
        } }));
}
exports.DependentFormControlledSelect = DependentFormControlledSelect;
//# sourceMappingURL=DependentFormControlledSelect.js.map